import React, { Suspense, useEffect, useState } from "react";
import {
  Box,
  Paper,
  Title,
  createStyles,
  Text,
  Select,
  Button,
  Tabs,
  SimpleGrid,
  Checkbox,
  Popover,
  Flex,
  Modal,
  Loader,
  Autocomplete,
  MultiSelect,
} from "@mantine/core";

import { forwardRef } from "react";
import exclamationSvg from "../../assets/img/Exclamation.svg";
import { IconChevronRight, IconDownload, IconUser, IconX } from "@tabler/icons-react";
import { IconUsers } from "@tabler/icons-react";
import { StyledTabs } from "./StyledTabs";
import { circularPlatformLogo, platformLogo } from "../../utils";
import RequestAccess from "./RequestAccess";
import { DownloadFile } from "./DownloadFile";
import EpicLogo from "../../assets/img/Epicc.svg";
import { useDisclosure } from "@mantine/hooks";
import { bulkKickOff, bulkStatus, downloadFile, getBulkClientList, getFileDataCount } from "./BulkExportService";
import { useMedplum } from "@medplum/react";
import JSONPretty from 'react-json-pretty';
import { showNotification } from "@mantine/notifications";
import ConfirmModal from "../../components/CustomModal";
import './viewertheme.css';

import {
  checkBoxesCerner,
  checkBoxesEpic,
  filterListCerner,
  filterListEpic,
  dateMap,
  groupA,
  groupB,
  groupLists,
  checkBoxesNextgen,
  checkBoxesEcw
} from "./BulkDataMap";


const useStyles = createStyles(() => ({
  paper: {
    borderRadius: "8px",
    marginLeft: "40px",
    marginRight: "40px",
    height: "100%",
    paddingLeft: "15px",
    paddingRight: "15px",
    paddingBottom: "40px",
  },

  title: {
    marginTop: "15px",
    fontWeight: 600,
    fontSize: "22px",
    lineHeight: "30px",
    color: "#262930",
    paddingTop: "12px",
    paddingBottom: "17px",
  },
  tabBox: {
    backgroundColor: "#F1F9FF",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "8px",
    padding: "8px",
  },
  selectPatientBox: {
    border: "1px solid #BEDEF8",
    width: "100%",

    display: "flex",
    flexDirection: "row",
    borderRadius: "8px",
    padding: "24px",
    gap: "24px",
  },
  patientGropuTitle: {
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "22px",
    color: "#262930",
    paddingLeft: "16px",
  },
  patientgroupText: {
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "20px",
    color: "#474E5B",
  },
  checkBoxBoxes: {
    border: "1px solid #BEDEF8",
    borderRadius: "8px",
    padding: "24px",
    marginTop: "24px",
    marginBottom: "24px",
  },
  typeTitle: {
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "20px",
    color: "#586171",
  },
  typefilterText: {
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "20px",
    color: "#262930",
  },
  popupText: {
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "20px",
    color: "#474E5B",
  },
  scrollBar: {
    height: "76vh",
    overflowY: "auto",
  },
}));

export const BulkExport = () => {
  const { classes } = useStyles();
  const medplum = useMedplum();

  const initForm = {
    groupId: '',
    resList: [],
    patients: [],
    typeFilter: '',
    startDate: ''
  }



  const [showDelete, setShowDelete] = useState<boolean>(false);
  const [value, setValue] = useState<any>("epic");
  const [clientList, setClientList] = useState<any>([]);
  const [opened, { close, open }] = useDisclosure(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  //Disclosures for tooltip
  const [opened0, { close: close0, open: open0 }] = useDisclosure(false);
  const [opened1, { close: close1, open: open1 }] = useDisclosure(false);
  const [opened2, { close: close2, open: open2 }] = useDisclosure(false);
  const [opened3, { close: close3, open: open3 }] = useDisclosure(false); // I know

  //Form States
  const [tab, setTab] = useState<string | null>('Group Level Export');
  const [formData, setFormData] = useState<any>(initForm);
  const [fileData, setFileData] = useState<any>();
  const [fileName, setFileName] = useState<string>('');
  const [fileList, setFileList] = useState<any>([]);
  const [filterList, setFilterList] = useState<string[]>(filterListEpic);
  const [patList, setPatList] = useState<string[]>([]);

  //Download and Progress 
  const [dLoader, setDLoader] = useState<number[]>([]);
  const [checkBoxes, setCheckBoxes] = useState<string[]>(checkBoxesEpic);
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [isExporting, setIsExporting] = useState<boolean>(false);
  const [progress, setProgress] = useState({
    progress: 0,
    total: 0,
  });

  const [groupList, setGroupList] = useState<any>([{
    value: "e3iabhmS8rsueyz7vaimuiaSmfGvi.QwjVXJANlPOgR83",
    label: "Group A - (e3iabhmS8rsueyz7vaimuiaSmfGvi.QwjVXJANlPOgR83)",
  }]);


  const data = [
    {
      image: EpicLogo,
      value: "epic",
      label: "Epic",
    },
    {
      image: platformLogo["cerner"],
      value: "cerner",
      label: "Cerner",
    },
    {
      image: platformLogo["ecw"],
      value: "ecw",
      label: "ECW",
    },
    {
      image: platformLogo["nextgen"],
      value: "nextgen",
      label: "NextGen",
    },
  ];


  interface ItemProps extends React.ComponentPropsWithoutRef<"div"> {
    image: string;
    label: string;
    description: string;
  }
  const SelectItem = forwardRef<HTMLDivElement, ItemProps>(
    ({ image, label, description, ...others }: ItemProps, ref) => (
      <div ref={ref} {...others}>
        <img src={image} style={{ marginLeft: "60px", height: "30px" }} />
      </div>
    )
  );




  useEffect(() => {
    const pL = groupA.map((p) => p.label)
    pL.push(...groupB.map((p) => p.label))
    setPatList(pL);
    getBulkClientList(medplum).then(
      (res) => {
        setClientList(res);
      }
    )

  }, []);

  const handleFilterChange = (val: any) => {
    checkBoxes.forEach((item: any) => {
      if (val.split('?').includes(item) && !formData.resList.includes(item)) {
        formData.resList.push(item);
      }
    })
    setFormData({ ...formData, typeFilter: val.split(' ')[0] })
  }
  const handleDelete = () => {
    setShowDelete(false);
    setFileList([]);
    setFileData(null);
    handleEhrChange("epic");
    setProgress({ progress: 0, total: 0 });
    setIsExporting(false);
    setFormData(initForm);
    setShowDeleteConfirmModal(false);
  };

  const handleEhrChange = (val: any) => {
    if (!val) return;
    setValue(val);
    setFormData(initForm);
    if (val === "epic") {
      setTab("Group Level Export");
      setFilterList(filterListEpic);
      setCheckBoxes(checkBoxesEpic);
      setGroupList(groupLists.epic);
    } else if (val === "cerner") {
      setCheckBoxes(checkBoxesCerner);
      setFilterList(filterListCerner);
      setGroupList(groupLists.cerner);
    } else if (val === "ecw") {
      setCheckBoxes(checkBoxesEcw);
      setFilterList(filterListEpic);
      setGroupList(groupLists.ecw);
    } else if (val === "nextgen") {
      setCheckBoxes(checkBoxesNextgen);
      setFilterList(filterListEpic);
      setGroupList(groupLists.nextgen);
    }
  }

  // const handleGroupChange = (val: any) => {
  //   setFormData({ ...formData, group: val });
  // }

  const handleCheckboxChange = (event: any) => {
    // Check if typeFilter's type is in event
    checkBoxes.forEach((item: any) => {
      if (formData.typeFilter.split('?').includes(item) && !event.includes(item)) {
        showNotification({ color: "red", message: "This type is included in Resource Filter. ", autoClose: true });
        event.push(item);
      }
    })

    if (event.includes("All") && !formData.resList.includes("All")) {
      event = [...checkBoxes];
    }
    else event = event.filter((item: any) => item !== "All");
    if (!event.includes("All") && event.length === checkBoxes.length - 1) {
      if (!formData.resList.includes("All")) event.push("All");
      else event = []
    }
    setFormData({ ...formData, resList: event });
  }

  const handleOpenFile = async (fileObject: any, download = false) => {
    setFileName(fileObject.type);
    setFileData(null);
    const payload = {
      contentUrl: fileObject.url,
      endpointId: value,
      clientId: clientList.find((item: any) => item.name.toLowerCase().includes(value))?.clientId
    }
    if (!download) setIsModalOpen(true);
    const resFil = await downloadFile(medplum, payload, fileObject.type);
    if (resFil) setFileData(resFil);
    else {
      setIsModalOpen(false);
      showNotification({ color: "red", message: "Something went wrong", autoClose: true });
    }
    if (download) await handleDowload(resFil)
  }

  const handleDowload = async (resFil?: any) => {
    const fil = resFil?.length ? resFil : fileData
    if (!fil) return;
    const url = URL.createObjectURL(new Blob([JSON.stringify(fil)], { type: 'application/json' }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${fileName}.json`);
    document.body.appendChild(link);
    link.click();
  }

  const handleSubmit = async () => {

    if (!formData.groupId && tab === "Group Level Export") {
      showNotification({ color: "red", message: "Please select group", autoClose: true });
      return;
    }
    if (!formData.patients?.length && tab === "Patient Level Export") {
      showNotification({ color: "red", message: "Please select a patient", autoClose: true });
      return;
    }
    if (!formData.resList.length) {
      showNotification({ color: "red", message: "Please select resource type", autoClose: true });
      return;
    }
    setShowDelete(false);
    setIsExporting(true);
    let pL: any = []
    if (formData.patients) {
      const patList = groupA.concat(groupB);
      formData.patients.forEach((item: any) => {
        const pat = patList.find((pat: any) => pat.label === item);
        if (pat) pL.push(pat)
      })
    }

    const filters = {
      resourceTypes: formData.resList.includes('All') ? [] : formData.resList,
      resourceFilters: formData.typeFilter
    }

    const currClient = clientList.find((item: any) => item.name.toLowerCase().includes(value));
    const payload = {
      endpointId: value,
      clientId: currClient?.clientId,
      groupId: formData.groupId,
      patientList: pL,
      filters,
      startDate: formData.startDate
    }
    setProgress({ progress: 10, total: 100 });
    const resKickOff = await bulkKickOff(medplum, payload);
    if (resKickOff.status === 400) {
      setIsExporting(false);
      showNotification({ color: "red", message: "Something went wrong " + resKickOff?.body?.error, autoClose: true });
      return;
    }

    const statusPayload = {
      endpointId: value,
      filters, // Filters is only required by ECW and the data is hardcoded i.e filter will be used to filter hardcoded data.
      clientId: currClient?.clientId,
      contentUrl: resKickOff.body.contentUrl
    };
    const fileList = await bulkStatus(medplum, setProgress, statusPayload) as any;
    if (fileList?.output) {
      setProgress({ progress: 90, total: 100 });
      const fileCountArr = await getFileDataCount(medplum, fileList?.output, value, currClient?.clientId);
      const filArr = fileList?.output.map((item: any, index: number) => {
        return {
          ...item,
          fileCount: fileCountArr[index] ?? ''
        }
      });
      setFileList(filArr);
      setProgress({ progress: 100, total: 100 });
      setIsExporting(false);
      setShowDelete(true);
    } else {
      showNotification({ color: "red", message: "Something went wrong", autoClose: true });
    };
  }


  return (
    <>
      <ConfirmModal
        isOpen={showDeleteConfirmModal}
        onClose={() => {
          setShowDeleteConfirmModal(false);
        }}
        title="Delete Bulk Export"
        message="Are you sure you want to delete this Bulk Export?"
        onCancel={() => setShowDeleteConfirmModal(false)}
        onConfirm={handleDelete}
        Button1="No"
        Button2="Delete"
      />
      <Modal
        // title={fileName}
        opened={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          setFileData(null);
        }}
        size="xl"
        withCloseButton={true}
        closeOnEscape={true}
        closeOnClickOutside={true}
      >
        {fileData ? (
          <>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                paddingBottom: "12px",
              }}
            >
              <Flex align="center">
                <Title className={classes.patientGropuTitle}>{fileName}</Title>
              </Flex>{" "}
              <Button onClick={handleDowload}>
                <IconDownload />
                <Text ml={8}>Download</Text>
              </Button>
            </Box>

            <div id="file-viewer" style={{ width: "100%", height: "100%" }}>
              <Suspense fallback={<div>Loading...</div>}>
                <Box className={classes.scrollBar}>
                  <JSONPretty id="json-pretty-1" data={fileData}></JSONPretty>
                </Box>
              </Suspense>
            </div>
          </>
        ) : (
          <Loader ml={"48%"} mb={20} color="blue" />
        )}
      </Modal>

      <Paper className={classes.paper}>
        <Title className={classes.title}>FHIR BULK Export</Title>
        <Box
          pt={24}
          pb={24}
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          {/* first with select and tabs */}
          <Box className={classes.tabBox}>
            <StyledTabs onMouseEnter={open3} onMouseLeave={close3} value={tab}>
              <Popover
                position="bottom"
                withArrow
                opened={opened3}
                disabled={value === "cerner" ? true : false}
              >
                <Popover.Target>
                  <Tabs.List>
                    <Tabs.Tab
                      value="Patient Level Export"
                      onClick={() => setTab("Patient Level Export")}
                      disabled={value === "cerner" ? false : true}
                    >
                      Patient Level Export
                    </Tabs.Tab>
                    <Tabs.Tab
                      onClick={() => {
                        setFormData({ ...formData, patients: [] });
                        setTab("Group Level Export");
                      }}
                      value="Group Level Export"
                    >
                      Group Level Export
                    </Tabs.Tab>
                  </Tabs.List>
                </Popover.Target>
                <Popover.Dropdown>
                  <Text className={classes.popupText}>
                    Only Group Level export is supported by{" "}
                    <span style={{ color: "#CD1041" }}>Epic</span>,{" "}
                    <span style={{ color: "#CD1041" }}>ECW</span> and{" "}
                    <span style={{ color: "#CD1041" }}> NextGen </span>.
                     </Text>
                </Popover.Dropdown>
              </Popover>
            </StyledTabs>
          </Box>
          <Box>
            <Select
              placeholder="Select EHR Type"
              size="lg"
              itemComponent={SelectItem}
              data={data}
              value={value}
              defaultValue={"epic"}
              onChange={handleEhrChange}
              clearable={true}
              rightSection={
                value === "epic" ? (
                  <img src={circularPlatformLogo["epic"]} />
                ) : value === "cerner" ? (
                  <img src={circularPlatformLogo["cerner"]} />
                ) : value === "ecw" ? (
                  <img src={circularPlatformLogo["ecw"]} />
                ) : (
                  <img src={circularPlatformLogo["nextGen"]} />
                )
              }
            />
          </Box>
        </Box>
        <Box>
          {/* seconf with select patient */}
          <Box className={classes.selectPatientBox}>
            <Box sx={{ minWidth: "50%" }}>
              <Box sx={{ display: "flex", flexDirection: "row" }}>
                <IconUsers />
                <Title className={classes.patientGropuTitle}>
                  Patient Group
                </Title>
              </Box>
              <Box>
                <Select
                  pt={16}
                  pb={16}
                  data={groupList}
                  value={formData.groupId}
                  onChange={(val: any) => {
                    if (val === "11ec-d16a-c763b73e-98e8-a31715e6a2bf")
                      setPatList(groupA.map((p) => p.label));
                    else setPatList(groupB.map((p) => p.label));
                    setFormData({ ...formData, groupId: val });
                  }}
                  size="lg"
                />
                <Text className={classes.patientgroupText}>
                  Instead of exporting all patients, you can select a group and
                  work with patients within that group
                </Text>
              </Box>
            </Box>
            <Box sx={{ minWidth: "50%" }}>
              <Box sx={{ display: "flex", flexDirection: "row" }}>
                <IconUser />
                <Title className={classes.patientGropuTitle}>Patient</Title>
              </Box>
              <Box pr={24}>
                <MultiSelect
                  pt={16}
                  pb={16}
                  data={patList}
                  clearable={true}
                  size="lg"
                  value={formData.patients}
                  onChange={(val: string[]) =>
                    setFormData({ ...formData, patients: val })
                  }
                  disabled={
                    value === "epic"
                      ? true
                      : tab === "Group Level Export"
                      ? true
                      : false
                  }
                />
                <Text className={classes.patientgroupText}>
                  Comma-separated list of patient IDs. When provided, the server
                  SHALL NOT return resources in the patient compartments
                  belonging to patients outside of this list.
                </Text>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box className={classes.checkBoxBoxes}>
          {/* third box with chechboxes */}
          <Box sx={{ display: "flex", flexDirection: "row" }}>
            <Title>Resources to export</Title>
            <Title
              className={classes.typeTitle}
              align="center"
              mt={7}
              ml={3}
              mr={6}
            >
              (_type)
            </Title>
            <img src="" />
            <Popover
              width={450}
              position="bottom"
              withArrow
              shadow="md"
              opened={opened0}
            >
              <Popover.Target>
                <img
                  src={exclamationSvg}
                  onMouseEnter={open0}
                  onMouseLeave={close0}
                />
              </Popover.Target>
              <Popover.Dropdown>
                <Text className={classes.popupText}>
                  The <span style={{ color: "blue" }}>_type </span>parameter
                  includes a list of ',' delimited resource types . Please
                  select the desired resources to export.
                </Text>
              </Popover.Dropdown>
            </Popover>
          </Box>
          <Box mb={24}>
            {" "}
            <Checkbox.Group
              value={formData?.resList}
              onChange={handleCheckboxChange}
            >
              <SimpleGrid cols={4} spacing="md" mt="xs">
                {checkBoxes.map((framework) => (
                  <Checkbox
                    //key={framework}
                    value={framework}
                    // checked={true}
                    // onClick={handleCheckboxChange}
                    label={framework}
                  />
                ))}
              </SimpleGrid>
            </Checkbox.Group>
          </Box>
          <Box>
            <Box sx={{ display: "flex", flexDirection: "row" }} mb={16}>
              <Title className={classes.typefilterText} mr={2}>
                Resource Filter
              </Title>
              <Title className={classes.typeTitle} align="center" mr={6}>
                (_typeFilter)
              </Title>
              <Popover
                width={450}
                position="bottom"
                withArrow
                shadow="md"
                opened={opened2}
              >
                <Popover.Target>
                  <img
                    src={exclamationSvg}
                    onMouseEnter={open2}
                    onMouseLeave={close2}
                  />
                </Popover.Target>
                <Popover.Dropdown>
                  <Text className={classes.popupText}>
                    To use<span style={{ color: "blue" }}>_typeFilter</span> for
                    a specific resource type, that resource must be included in
                    the _type parameter. You cannot use _typeFilter without also
                    using _type. Query strings for multiple resources can be
                    included in _typeFilter.Query strings in the _typeFilter
                    parameter use the same search parameters as the R4 search
                    APIs, and are formatted in much the same way. The general
                    format is “_typeFilter=
                    <span style={{ color: "blue" }}>
                      MedicationRequest?category=inpatient
                    </span>
                    ” The standard query string reserved characters (question
                    mark, equals sign, and ampersand) must be URL encoded within
                    _typeFilter and commas must be backslash escaped.
                  </Text>
                </Popover.Dropdown>
              </Popover>
            </Box>
            <Autocomplete
              size="lg"
              rightSection={
                formData.typeFilter && (
                  <IconX
                    onClick={() => setFormData({ ...formData, typeFilter: "" })}
                  />
                )
              }
              data={filterList}
              value={formData.typeFilter}
              onChange={handleFilterChange}
            />
            <Title className={classes.patientgroupText} mt={16} mb={24}>
              The _typeFilter parameter accepts a comma-delimited list of FHIR
              resource search queries. This is used to filter the results of the
              bulk data export so you can retrieve only the data you need
            </Title>
          </Box>

          <Box sx={{ display: "flex", flexDirection: "row", gap: "24px" }}>
            {/* since includes data */}
            <Box sx={{ minWidth: "50%" }}>
              <Box sx={{ display: "flex", flexDirection: "row" }}>
                <Title className={classes.typefilterText} mr={2}>
                  Filter by Modification Date/Time
                </Title>
                <Title className={classes.typeTitle} align="center" mr={6}>
                  (_since)
                </Title>
                <Popover
                  width={450}
                  position="bottom"
                  withArrow
                  shadow="md"
                  opened={opened}
                >
                  <Popover.Target>
                    <img
                      src={exclamationSvg}
                      onMouseEnter={open}
                      onMouseLeave={close}
                    />
                  </Popover.Target>
                  <Popover.Dropdown>
                    <Text className={classes.popupText}>
                      You can filter the data and only include resources that
                      have been modified after the specified date.
                    </Text>
                  </Popover.Dropdown>
                </Popover>
              </Box>
              <Box>
                <Select
                  disabled={value === "epic"}
                  pt={16}
                  pb={16}
                  data={dateMap}
                  value={formData.startDate}
                  onChange={(val) =>
                    setFormData({ ...formData, startDate: val })
                  }
                  size="lg"
                />
                <Text
                  sx={{
                    fontWeight: 400,
                    fontSize: "12px",
                    lineHeight: "20px",
                    color: "#474E5B",
                  }}
                >
                  Use the _since parameter to limit the export to only the
                  relevant date range.
                </Text>
              </Box>
            </Box>
            <Box sx={{ minWidth: "50%" }}>
              <Box sx={{ display: "flex", flexDirection: "row" }}>
                <Title
                  sx={{
                    fontWeight: 500,
                    fontSize: "14px",
                    lineHeight: "20px",
                    color: "#262930",
                  }}
                  mr={2}
                >
                  Associated Data
                </Title>
                <Title className={classes.typeTitle} align="center" mr={6}>
                  (_includeAssociatedData)
                </Title>
                <Popover
                  width={450}
                  position="bottom"
                  withArrow
                  shadow="md"
                  opened={opened1}
                >
                  <Popover.Target>
                    <img
                      src={exclamationSvg}
                      onMouseEnter={open1}
                      onMouseLeave={close1}
                    />
                  </Popover.Target>
                  <Popover.Dropdown>
                    <Text className={classes.popupText}>
                      The includeAssociatedData parameter can be set to
                      "LatestProvenanceResources" to include the Provenance
                      resource associated with each resource instance included
                      in the bulk data files.
                    </Text>
                  </Popover.Dropdown>
                </Popover>
              </Box>
              <Box pr={24}>
                <Select
                  pt={16}
                  pb={16}
                  data={["LatestProvenanceResources"]}
                  size="lg"
                  disabled={value === "ecw" || value === "nextgen"}
                />
                <Text
                  sx={{
                    fontWeight: 400,
                    fontSize: "12px",
                    lineHeight: "20px",
                    color: "#474E5B",
                  }}
                >
                  Comma-separated list of patient IDs. When provided, the server
                  SHALL NOT return resources in the patient compartments
                  belonging to patients outside of this list.
                </Text>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            padding: "12px",
            backgroundColor: "#F1F9FF",
            borderRadius: "4px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Title sx={{ display: "flex", flexDirection: "row" }}>
              <img src="" />
              <Title>Kick-off Request</Title>
            </Title>
            <Title
              sx={{
                fontWeight: 500,
                fontSize: "14px",
                lineHeight: "20px",
                color: "#262930",
              }}
            >
              The request above returns results for a default set of R4
              resources in the ndjson format.
            </Title>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button disabled={isExporting} onClick={handleSubmit} size="md">
              Start export{" "}
              <IconChevronRight style={{ height: "16px", marginLeft: "8px" }} />
            </Button>
          </Box>
        </Box>
        <Box>
          {(isExporting || showDelete) && (
            <RequestAccess
              progress={progress.progress}
              total={progress.total}
              done={showDelete ? 1 : 0}
            />
          )}
        </Box>

        <Box>
          {showDelete ? (
            <DownloadFile
              handleDowload={handleOpenFile}
              filesData={fileList}
              loader={[dLoader, setDLoader]}
              onDelete={() => setShowDeleteConfirmModal(true)}
            />
          ) : (
            <Box></Box>
          )}
        </Box>
      </Paper>
    </>
  );
};

export default BulkExport;
